import type { AddressSuggestion, Commune, NearbyCompetition } from '@shared/types/entities';

import { api } from './client';

export type { AddressSuggestion, Commune, NearbyCompetition };

export const searchCommunesApi = (q: string, department?: string, limit = 10): Promise<Commune[]> => {
  const params = new URLSearchParams({ q, limit: String(limit) });
  if (department) params.set('department', department);
  return api.get<Commune[]>(`/geo/communes/search?${params.toString()}`);
};

export const getCommuneApi = (citycode: string): Promise<Commune> => api.get<Commune>(`/geo/communes/${citycode}`);

export const geocodeAddressApi = (q: string): Promise<AddressSuggestion[]> =>
  api.get<AddressSuggestion[]>(`/geo/address/search?q=${encodeURIComponent(q)}`);

export const getNearbyCompetitionsApi = (
  lat: number,
  lng: number,
  radiusKm = 50,
  status?: string,
  limit = 20,
): Promise<NearbyCompetition[]> => {
  const params = new URLSearchParams({
    lat: String(lat),
    lng: String(lng),
    radius: String(radiusKm),
    limit: String(limit),
  });
  if (status) params.set('status', status);
  return api.get<NearbyCompetition[]>(`/geo/competitions/nearby?${params.toString()}`);
};
